import { render, staticRenderFns } from "./detailsForm.vue?vue&type=template&id=85abe3f6&"
import script from "./detailsForm.vue?vue&type=script&lang=js&"
export * from "./detailsForm.vue?vue&type=script&lang=js&"
import style0 from "./detailsForm.vue?vue&type=style&index=0&id=85abe3f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports